<mt-button (submitEvent)="downloadAsset()">
  <mt-icon-download></mt-icon-download>
  Download
</mt-button>
